import type { SiloDiscoveryRecommendation } from '@main/datamap-types';

export const getIdForGuess = ({
  pluginId,
  resourceId,
}: Pick<SiloDiscoveryRecommendation, 'pluginId' | 'resourceId'>): string =>
  `${pluginId}|${resourceId}`;
